import { Performer } from "lib/types/item/performer";
import buttonStyles from '@styles/scss/buttons/_buttons.module.scss';
import styles from '@styles/scss/performer/_imageGallery.module.scss';
import { ImageGallery } from "lib/types/item/imageGallery";
export const ImageGalleryCta: React.FC<{
  performer: Performer;
  gender: string;
  currentLang: string;
  height?: number | string;
  width?: number | string;
  imageGallery: ImageGallery;
}> = ({ performer, gender, currentLang, height, width, imageGallery }) => (
  <div className={styles.ctaContainer} style={{ height: height, width: width }}>
    <img
      className={styles.ctaImage}
      src={performer.card_image}
      alt="Join Now"
      style={{ height: '100%', width: '100%', objectFit: 'cover' }}
    />
    <div className={styles.ctaContent}>
      <h3>{imageGallery.cta_title}</h3>
      <a
        className={buttonStyles.primaryButton}
        href={`https://rabbits.webcam/?id=2333&product_id=36&tag=signup&passthru1=${gender}&passthru2=${currentLang}&exid={exid}&tfid={tfid}`}
        data-event-category="Outbound Click"
        data-event-action="CTA Interstitial Photos"
        data-event-label="Button-CTA">
        <span>{imageGallery.cta_button}</span>
      </a>
    </div>

  </div>
)